import { mount } from "svelte";
import App from "./App.svelte";
import { polyfill } from "./polyfill";
import { initCognitoClient } from "./state/cognitoClient.svelte";
import { globalState } from "./state/globalState.svelte";

// A dynamic import can fail to load its chunk if a new deploy removed the hashed file the page
// still references. Vite dispatches this event for any such failure; reloading fetches the current
// build. Guarded to a single attempt so a genuinely broken chunk doesn't reload-loop the tab.
window.addEventListener("vite:preloadError", () => {
	const reloadedKey = "vite-preload-error-reloaded";
	if (window.sessionStorage.getItem(reloadedKey)) {
		return;
	}
	window.sessionStorage.setItem(reloadedKey, "true");
	window.location.reload();
});

await polyfill();

if (import.meta.env.PROD) {
	const { setupSentry } = await import("./utils/setupSentry.js");
	setupSentry();
}

await initCognitoClient();

const root = document.querySelector("#root");
if (!root) {
	throw new Error("Could not find root element");
}

globalState.userAgent = window.navigator.userAgent;
mount(App, { target: root });
